import React from 'react';
import { useBeats } from '../../../hooks/useBeats';
import { Pill } from '../Pill';
import { StageLayout } from '../StageLayout';
import { Portrait } from '../Portrait';
import { BRAND } from '../../../data/teaser';
import { portraits } from '../../../data/tracking';
interface Page1ContractProps {
  onBegin: () => void;
}
const BEATS = [900, 1500];

/** The contract. The clinical question only — no product, no promise yet. */
export function Page1Contract({
  onBegin
}: Page1ContractProps) {
  const beat = useBeats(BEATS);
  return <StageLayout centered bleed={<div className="h-full w-full opacity-0-init animate-fade-in" data-id="element-166" data-mp="2drhh87mcxcok">
          <Portrait src={portraits.clinician.image} alt={portraits.clinician.alt} data-id="element-167" data-mp="2dpmwouezzml0" />
        </div>} copy={<>
          <p className="font-body text-[11px] font-semibold tracking-[0.32em] text-white/40 opacity-0-init animate-fade-in" data-id="element-168" data-mp="23s8fgsl92trn">
            {BRAND}
          </p>

          <p className="mt-5 font-body text-xs text-white/45 opacity-0-init animate-fade-in-up md:text-sm" style={{
      animationDelay: '120ms'
    }} data-id="element-169" data-mp="2x9g51luu3oy5">
            Invest 30 seconds.
          </p>

          <h1 className="mt-2 font-headline text-[30px] font-extrabold leading-[1.08] text-white opacity-0-init animate-fade-in-up md:text-[52px]" style={{
      animationDelay: '220ms'
    }} data-id="element-170" data-mp="2nbrze0vowx17">
            Why do some cases not track as planned?
          </h1>

          <p className={`mt-5 font-body text-sm text-solventum-primary transition-[opacity,transform] duration-300 ease-out md:text-lg ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-171" data-mp="3kzaf5vnrqzep">
            One variable may deserve a closer look.
          </p>

          <div className={`mt-8 transition-[opacity,transform] duration-200 ease-out ${beat >= 2 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-172" data-mp="1uljomu3hhewn">
            <Pill onClick={onBegin} tone="accent" className="px-5" data-id="element-173" data-mp="625rkkji42wd">
              Begin →
            </Pill>
          </div>
        </>} data-id="element-165" data-mp="2hrrnlle2a53y" />;
}